import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

/**
 * Our own routing strategy for telling angular where to not reuse component while changing route.
 * It's used via data parameter "reuseComponent" in route config.
 */
export class CustomReuseStrategy implements RouteReuseStrategy {
  // Default methods we don't care about
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {}
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // We don't want to reuse the component (use with caution)
    if (future.data['reuseComponent'] === false) {
      return false;
    }

    // Use the standard angular logic, reuse the component
    return future.routeConfig === curr.routeConfig;
  }
}
